
const Footer = () => {
    return (
        <>
            <div className='relative top-0 left-0 w-100 text-center text-md ' >

                <h2>Made With <span className='text-red-500'>♥️</span> By 
Coding With Mr.M</h2>
            </div >
        </>
    )
}

export { Footer }
